import React, { useEffect, useId, useRef, useState } from 'react';

const CompanyPicker = ({ companies, value, onChange, label, disabled }) => {
  const id = useId();
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const activeOption = useRef(null);
  const selected = companies.find((company) => company.ticker === value);
  const matches = companies.filter((company) =>
    `${company.ticker} ${company.name || ''} ${company.subsection || ''}`.toLowerCase().includes(query.trim().toLowerCase())
  );
  const expanded = open && !disabled;
  const choose = (company) => {
    onChange(company.ticker);
    setQuery('');
    setOpen(false);
    setActiveIndex(-1);
  };

  useEffect(() => {
    if (expanded && activeIndex >= 0) activeOption.current?.scrollIntoView?.({ block: 'nearest' });
  }, [activeIndex, expanded]);

  return <div className="company-picker">
    <label htmlFor={id}>{label}</label>
    <input id={id} role="combobox" aria-autocomplete="list" aria-expanded={expanded}
      aria-controls={`${id}-options`} aria-activedescendant={expanded && activeIndex >= 0 ? `${id}-option-${activeIndex}` : undefined}
      autoComplete="off" placeholder="Search by company, ticker or subsection"
      disabled={disabled || !companies.length} value={selected ? `${selected.ticker} - ${selected.name || selected.ticker}` : query}
      onFocus={() => { setOpen(true); setActiveIndex(-1); }}
      onClick={() => setOpen(true)} onBlur={() => { setOpen(false); setActiveIndex(-1); }}
      onChange={(event) => { setQuery(event.target.value); onChange(''); setActiveIndex(-1); setOpen(true); }}
      onKeyDown={(event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          setOpen(true);
          setActiveIndex((current) => matches.length ? event.key === 'ArrowDown'
            ? Math.min(current + 1, matches.length - 1)
            : current < 0 ? matches.length - 1 : Math.max(current - 1, 0) : -1);
        } else if (event.key === 'Enter' && expanded) {
          event.preventDefault();
          if (activeIndex >= 0 && matches[activeIndex]) choose(matches[activeIndex]);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          setActiveIndex(-1);
        }
      }} />
    {expanded && <div className="company-picker-dropdown">
      <ul id={`${id}-options`} role="listbox" aria-label={label}>
        {matches.map((company, index) => <li key={company.ticker} id={`${id}-option-${index}`} role="option"
          aria-selected={company.ticker === value} ref={index === activeIndex ? activeOption : null}
          className={index === activeIndex ? 'active' : ''}
          onMouseDown={(event) => event.preventDefault()} onClick={() => choose(company)}>
          <strong>{company.ticker}</strong><span>{company.name || company.ticker}</span>
          {(company.subsection || company.pre_ipo) && <small>{[company.subsection, company.pre_ipo && 'Pre-IPO'].filter(Boolean).join(' · ')}</small>}
        </li>)}
      </ul>
      {!matches.length && <p role="status">No live companies match your search.</p>}
    </div>}
    {!companies.length && <p className="muted">No live companies are available to select.</p>}
  </div>;
};

export default CompanyPicker;
